<script lang="ts">
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { ResponsiveVars } from '@twist/core';
  import ChevronLeft from '@twist/icons/lib/ChevronLeft.svg?component';
  import { flagValue } from '$lib/context/flags';
  import { FEATURE_FLAGS } from '$lib/flags/constants';
  import FontSizeDecorator from '$components/SanityComponents/PortableText/Decorators/FontSizeDecorator.svelte';

  export let text: string;
  export let to: string;

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(15, 15))
    .addFluid('spacing', toFluidVarInput(6, 6))
    .toCSS();

  $: brandReskinEnabled = flagValue(FEATURE_FLAGS.BRAND_RESKIN);
</script>

{#if brandReskinEnabled}
  <a class="reskin-link" href={to}>
    <ChevronLeft />
    <FontSizeDecorator size="breadcrumb">
      {text}
    </FontSizeDecorator>
  </a>;
{:else}
  <a class={responsiveVars} href={to}>
    <ChevronLeft />

    {text}
  </a>;
{/if}

<style lang="scss">
  a {
    color: white;
    text-decoration: none;
    font-weight: 700;
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    line-height: 130%;
    letter-spacing: 1px;
    display: inline-flex;
    align-items: center;
    gap: var(--spacing);
    transition: color var(--twist-duration-100) var(--twist-ease-in-out-1);

    &:hover,
    &:focus-visible {
      color: var(--twist-color-gray-30);
    }
  }

  .reskin-link {
    gap: 10px;
  }
</style>
